<script setup>
import { ref } from 'vue';
import ContactsModal from './ContactsModal.vue';
import { openUrlWithFakeTag } from '@/Services/agendartMobileAppUtils';
import { getWhatsAppUrl } from '@/Services/websiteContactUtils';


const props = defineProps({
    web_site: Object,
    hasBlog: Boolean,
    preview: Boolean,
    selfSchedulingLink: String
})

const color = ref(props.web_site.color)
const menuOpen = ref(false);
const toggleMenu = () => {
    menuOpen.value = !menuOpen.value;
}

const goToWebsite = () => {
    openUrlWithFakeTag('/p/' + props.web_site.page_url, '_blank');
}

const isDialogOpen = ref(false);
const openDialog = () => { isDialogOpen.value = true; };
const closeDialog = () => { isDialogOpen.value = false; };
const openScheduling = () => {
    if (props.selfSchedulingLink) {
        openUrlWithFakeTag(props.selfSchedulingLink, '_blank');
        return;
    }

    const whatsappUrl = getWhatsAppUrl(props.web_site.contact?.whats_app, 'Olá, gostaria de saber mais sobre seu atendimento.');
    if (whatsappUrl) {
        openUrlWithFakeTag(whatsappUrl, '_blank');
        return;
    }

    openDialog();
};

</script>

<template>
    <div v-if="preview" class="relative w-full bg-[#f5f1fb]">
        <p class="py-3 text-center text-sm font-light text-[#5c6873]">
            {{$t('preview_notice')}}
            <a @click="goToWebsite" class="cursor-pointer font-semibold" :style="{ color }">{{ $t('public_site')}}</a>
        </p>
    </div>
    <header class="relative z-20 bg-white">
        <div class="container mx-auto flex items-center justify-between gap-4 px-5 py-2 md:px-6">
            <button
                type="button"
                @click="toggleMenu"
                class="flex size-10 items-center justify-center rounded-full text-lg text-[#3f444a] md:hidden"
                :aria-expanded="menuOpen"
                aria-label="Abrir menu"
            >
                <i class="fa-solid fa-bars"></i>
            </button>
            <a :href="route('index.marketing.website', { user: web_site.page_url })" class="flex min-w-0 items-center md:mr-auto">
                <img
                    v-if="web_site.image?.logo_path_url"
                    :src="web_site.image?.logo_path_url"
                    :alt="web_site.text?.name || 'Logo'"
                    class="h-12 max-w-52 object-contain md:h-16 md:max-w-64"
                />
                <span v-else class="text-2xl font-bold tracking-tight md:text-3xl" :style="{ color }">agendart</span>
            </a>
            <nav
                class="absolute left-0 right-0 top-full flex-col border-t border-gray-100 bg-white px-5 py-4 shadow-lg md:static md:flex md:flex-row md:items-center md:gap-3 md:border-0 md:p-0 md:shadow-none"
                :class="menuOpen ? 'flex' : 'hidden'"
            >
                <button
                    v-if="web_site.contact?.whats_app || web_site.contact?.telephone || web_site.contact?.email"
                    type="button"
                    class="rounded-full border px-5 py-2 text-sm font-semibold"
                    :style="{ color, borderColor: color }"
                    @click="openDialog"
                >{{ $t('contact') }}</button>
                <button
                    type="button"
                    class="rounded-full px-5 py-2 text-sm font-semibold text-white"
                    :style="{ backgroundColor: color }"
                    @click="openScheduling"
                >{{ $t('schedule_now') }}</button>
            </nav>
        </div>
    </header>

    <ContactsModal :visible="isDialogOpen" @close="closeDialog" :web_site="web_site" :selfSchedulingLink="selfSchedulingLink"/>


</template>
